import { from } from 'rxjs'
import { switchMap, filter, withLatestFrom } from 'rxjs/operators'
import Actions from '../actions'
import { getPayload } from '../utils/rxUtils'
import { setLocale } from '../i18n'
import { combineLatest } from 'rxjs'
import {
  getLocaleFromLanguage,
  getLanguageFromLocale,
} from '../utils/fetchUtils'
import { of } from 'rxjs'

export const changeLocale = action$ => {
  return action$.pipe(
    getPayload(Actions.CHANGE_LOCALE_REQUESTED),
    filter(({ locale }) => locale),
    switchMap(({ locale }) => {
      return setLocale(locale)
    }),
    switchMap(locale =>
      from([
        Actions.createAction(Actions.CHANGE_LOCALE_RECEIVED, {
          locale,
        }),
      ])
    )
  )
}

// after login - update language in profile(be) when locale changed before login
export const updateLanguageIfLocaleChanged = (action$, state$) => {
  const profile$ = action$.pipe(getPayload(Actions.USER_PROFILE_RECEIVED))
  const reset$ = action$.pipe(getPayload(Actions.SYSTEM_LANGUAGES_RECEIVED))

  return combineLatest([reset$, profile$]).pipe(
    withLatestFrom(state$),
    filter(([_, state]) => !!state.locale.selectedLocale),
    switchMap(([_, state]) => {
      return of(
        Actions.createAction(Actions.UPDATE_LANGUAGE_REQUESTED, {
          language: getLanguageFromLocale(
            state?.locale?.selectedLocale,
            state.app?.languages
          ),
        })
      )
    })
  )
}

// after login - change locale to user's language when locale NOT changed before login
export const changeLocaleAfterProfileReceived = (action$, state$) => {
  const profile$ = action$.pipe(getPayload(Actions.USER_PROFILE_RECEIVED))
  const reset$ = action$.pipe(getPayload(Actions.SYSTEM_LANGUAGES_RECEIVED))

  return combineLatest([reset$, profile$]).pipe(
    withLatestFrom(state$),
    filter(([_, state]) => !state.locale.selectedLocale),
    switchMap(([_, state]) => {
      return of(
        Actions.createAction(Actions.CHANGE_LOCALE_REQUESTED, {
          locale: getLocaleFromLanguage(
            state?.profile?.userDetails?.language,
            state.app?.languages
          ),
        })
      )
    })
  )
}

// after update language - change locale to user's language
export const changeLocaleAfterUpdateLanguage = (action$, state$) => {
  return action$.pipe(
    getPayload(Actions.UPDATE_LANGUAGE_RECEIVED),
    withLatestFrom(state$),
    switchMap(([{ language }, state]) => {
      return of(
        Actions.createAction(Actions.CHANGE_LOCALE_REQUESTED, {
          locale: getLocaleFromLanguage(language, state.app?.languages),
        })
      )
    })
  )
}

// change locale after switch language before login
export const changeLocaleAfterSwitchLanguage = (action$, state$) => {
  return action$.pipe(
    getPayload(Actions.SELECT_CHANGE_LOCALE_REQUESTED),
    withLatestFrom(state$),
    filter(([_, state]) => !state?.profile?.userDetails?.id),
    switchMap(([{ locale }, state]) => {
      return of(
        Actions.createAction(Actions.CHANGE_LOCALE_REQUESTED, {
          locale: locale,
        })
      )
    })
  )
}

// update language after switch language after login
export const updateLanguageIfSwitchLocale = (action$, state$) => {
  return action$.pipe(
    getPayload(Actions.SELECT_CHANGE_LOCALE_REQUESTED),
    withLatestFrom(state$),
    filter(([_, state]) => !!state?.profile?.userDetails?.id),
    switchMap(([{ locale }, state]) => {
      return of(
        Actions.createAction(Actions.UPDATE_LANGUAGE_REQUESTED, {
          language: getLanguageFromLocale(locale, state.app?.languages),
        })
      )
    })
  )
}
